'use strict';
var twentyninetimes = twentyninetimes || {};
const featuredCases = document.querySelectorAll('.js-featured-cases');

twentyninetimes.featuredCases = twentyninetimes.featuredCases || function () {

	function init() {
        if(featuredCases && featuredCases.length > 0 && window.innerWidth > 991) {
            for (let i = 0; i < featuredCases.length; i++) {
                const currentBlock = featuredCases[i];
                const content = currentBlock.querySelector('.js-featured-cases-content');
                const contentInner = content.querySelector('.js-featured-cases-content-inner');
                let bottomMargin = contentInner.offsetHeight;


                // content.style.marginBottom = bottomMargin + 'px';

                let contentHeight = content.getBoundingClientRect().height;
                let contentInnerHeight = contentInner.getBoundingClientRect().height;

                console.log(contentInnerHeight);

                content.style.height = (contentInnerHeight) + 'px';
                // content.style.height = '300px';

                // content.style.marginBottom = (contentHeight) + 'px';

                const isEdge = window.navigator.userAgent.indexOf('Edg') > -1;
                
                if (isEdge) {
                    // Do something for Microsoft Edge
                    content.style.height = bottomMargin + 'px';
                }
            }
        }
	}

	return {
		init : init
	};

}();